import axios from 'axios';
import { Repository } from './Repository';

export class WebinarRepository extends Repository {
	constructor(nonce) {
		super(nonce);
	}

	getUpcomingWebinarsData(request) {
		const nonce = this.nonce;
		Object.assign(request, { nonce });
		Object.assign(request, { action: 'get_upcoming_webinars_data' });

		return this.post(request);
	}
}
